import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { useEffect } from 'react';
import { getMfeCacheBuster } from '@/common/MicroFrontEnds';
import SectionLoader from '@/vdp/SectionLoader';
import AvailabilityAction from '~/constants/availabilityAction';
import { Options } from '~/utilities/errorHandlers';

type OwnProps = {
  analyticsCorrelationId: string;
  availabilityAction: AvailabilityAction;
  deliveryPickupRouteId?: string;
  errorLogger: (
    _error: Error,
    _context?: Record<string, any>,
    _options?: Options
  ) => void;
  fairMarketValue: number;
  hasTradeIncentive: boolean;
  make: string;
  marketValueLoadedDateTime: string;
  model: string;
  price: number;
  referrer: string;
  searchRequestId: string;
  vehicleId: number;
};

function PriceDetails(props: OwnProps) {
  useEffect(() => {
    MfeLoad({
      files: [
        [
          'PriceDetailsModule',
          [
            {
              component: 'default',
              default: {
                file: 'index.js',
                manifest: `${
                  process.env.CVNA_APP_CDNSTATIC_BASE_URL
                }/finx-price-details/assets-manifest.json?v=${getMfeCacheBuster()}`
              }
            }
          ]
        ]
      ]
    });
  }, []);

  return (
    <MfeReactComponent
      component="default"
      module="PriceDetailsModule"
      loading={
        <SectionLoader
          skeletonHeight={{ mobile: 1097, tablet: 611, desktop: 611 }}
        />
      }
      {...props}
    />
  );
}

export default PriceDetails;
